import { SCROLL_TO_TAB_OFFSET } from 'Component/ProductTabs/ProductTabs.config';
import { ProductTabs as SourceProductTabs } from 'SourceComponent/ProductTabs/ProductTabs.component';

/** @namespace Advox/Component/ProductTabs/Component */
export class ProductTabs extends SourceProductTabs {
    state = {
        inViewport: false,
    };

    onTabClick = (tab) => {
        const { tabs } = this.props;
        const { activeTab } = this.state;

        const currentTab = tabs.findIndex(({ name }) => name === tab);

        if (activeTab !== currentTab) {
            const { tabKey } = tabs[currentTab];
            const tabContent = document.getElementById(tabKey);

            if (tabContent) {
                const { top } = tabContent.getBoundingClientRect();
                window.scrollTo({ top: top + window.scrollY - SCROLL_TO_TAB_OFFSET, behavior: 'smooth' });
            }

            this.setState({
                activeTab: currentTab,
            });
        }
    };

    renderAllTabsFromGroup(tabGroup) {
        const { tabs } = this.props;

        return tabs.map(({ render, name, group }) => (group === tabGroup ? render(name) : null));
    }

    renderTabs() {
        const { tabs, inViewPort, withHeader, group } = this.props;

        return (
            <div id={`ProductTabs-${group}`}>
                {withHeader ? (
                    <ul block="ProductTabs" mods={{ inViewPort }}>
                        {tabs.map(this.renderTab.bind(this))}
                    </ul>
                ) : null}

                {!group ? this.renderAllTabs() : this.renderAllTabsFromGroup(group)}
            </div>
        );
    }
}

export default ProductTabs;
